const doc = [({"ja":({"platformId":"プラットフォームID", "name":"氏名", "subject":"件名", "text":"本文"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;